// Convert Arabic-Indic digits (٠-٩) and Persian digits (۰-۹) → Latin (0-9).
// Applied at the frontend data-layer so we don't need to touch the
// backend seed. Purely presentational.
//
// Also strips Arabic-Indic decimal separator (U+066B) → ASCII '.' since it
// otherwise mixes awkwardly with Latin digits.

const AR_TO_LATIN = {
  "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
  "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9",
  "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
  "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9",
  "٫": ".",   // Arabic decimal separator
  "٬": ",",   // Arabic thousands separator
};

const RE = /[٠-٩۰-۹٫٬]/g;

export const toLatinDigits = (input) => {
  if (input == null) return input;
  if (typeof input !== "string") return input;
  return input.replace(RE, (ch) => AR_TO_LATIN[ch] ?? ch);
};

/** Deep-clone an object tree, converting every string leaf to Latin digits.
 *  Non-string leaves pass through unchanged. Cycles are not expected in
 *  API payloads so we don't guard against them. */
export const normalizeDigitsDeep = (value) => {
  if (value == null) return value;
  if (typeof value === "string") return toLatinDigits(value);
  if (Array.isArray(value)) return value.map(normalizeDigitsDeep);
  if (typeof value === "object") {
    const out = {};
    for (const k of Object.keys(value)) {
      out[k] = normalizeDigitsDeep(value[k]);
    }
    return out;
  }
  return value;
};
